import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/Providers";
import { CartLines } from "@/components/CartLines";
import { CartSummary } from "@/components/CartSummary";

export const CartDrawer = () => {
  const { open, setOpen, items } = useCart();
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="flex w-full flex-col border-line bg-ink p-0 text-gray-100 sm:max-w-md" data-testid="cart-drawer">
        <div className="border-b border-line px-6 py-5">
          <SheetTitle className="font-display text-2xl text-white">Your Cart</SheetTitle>
        </div>
        {items.length ? (
          <>
            <div className="flex-1 overflow-y-auto px-6"><CartLines compact onNavigate={close} /></div>
            <div className="border-t border-line px-6 py-5">
              <CartSummary />
              <div className="mt-3 flex justify-between text-sm">
                <button type="button" onClick={close} className="link-gold" data-testid="cart-continue-shopping-button">Continue shopping</button>
                <Link to="/cart/" onClick={close} className="link-gold" data-testid="cart-view-full-link">View full cart</Link>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-1 flex-col items-center justify-center px-6 text-center" data-testid="cart-empty">
            <ShoppingBag className="h-10 w-10 text-gray-600" aria-hidden />
            <p className="mt-4 text-lg text-white">Your cart is empty</p>
            <Link to="/shop/" onClick={close} className="btn-gold mt-6" data-testid="cart-empty-shop-button">Browse the menu</Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
